/* unplugin-vue-components disabled */import { render } from "./MicroHeadlines.vue?vue&type=template&id=faa4f472&scoped=true"
import script from "./MicroHeadlines.vue?vue&type=script&lang=js"
export * from "./MicroHeadlines.vue?vue&type=script&lang=js"

import "./MicroHeadlines.vue?vue&type=style&index=0&id=faa4f472&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faa4f472"]])

export default __exports__